import { Typography } from '@mui/material';
import styled from '@mui/styled-engine';

export const StyledHeaderSection = styled(Typography)(
  ({ theme }) => `
  color: ${theme.palette.secondary.dark};
`
);
